module.exports = __webpack_public_path__ + "static/media/show.2c40973b.png";